import { apiSlice } from './apiSlice';
import { BILLS_URL } from '../constants';

export const billsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new bill
    createBill: builder.mutation({
      query: (bill) => ({
        url: BILLS_URL,
        method: 'POST',
        body: bill,
      }),
    }),
    // Get bill details by ID
    getBillDetails: builder.query({
      query: (id) => ({
        url: `${BILLS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get logged-in user's bills
    getMyBills: builder.query({
      query: () => ({
        url: `${BILLS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),
    // Get all bills (Admin view)
    getBills: builder.query({
      query: () => ({
        url: BILLS_URL,
      }),
      keepUnusedDataFor: 5,
    }),
    // Mark a bill as delivered (Admin action)
    deliverBill: builder.mutation({
      query: (billId) => ({
        url: `${BILLS_URL}/${billId}/deliver`,
        method: 'PUT',
      }),
    }),
    // Delete a bill (Admin action)
    deleteBill: builder.mutation({
      query: (billId) => ({
        url: `${BILLS_URL}/${billId}`,
        method: 'DELETE',
      }),
    }),
    // Update a bill
    updateBill: builder.mutation({
      query: ({ billId, updatedBill }) => ({
        url: `${BILLS_URL}/${billId}`,
        method: 'PUT',
        body: updatedBill,
      }),
    }),
  }),
});

export const {
  useCreateBillMutation,
  useGetBillDetailsQuery,
  useGetMyBillsQuery,
  useGetBillsQuery,
  useDeliverBillMutation,
  useDeleteBillMutation,
  useUpdateBillMutation, // Newly added export
} = billsApiSlice;